module.exports = __webpack_public_path__ + "static/media/externalBarn_7.c9f227e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_7.png
// module id = 1311
// module chunks = 3